import Model from 'src/storage/base';
import constants from 'src/constants';
import { popupModel } from '../../../components/complex';
import { getRouter } from '../../../helpers';

class MainModel extends Model {
  id = 'main';
  persistent = true;
  defaultState = () => ({
    currency: constants.general.defaultCurrency,
    tabs: {
      main_treatment: 'treatment',
      main_message: 'chat'
    },
    isOpenBookAppointment: false,
    images: []
  });
  apiConfig = {
    login: {
      url: '/admin/doctor/login',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };
  _events = {
    selected_contact: 'onSetContact',
    profile: 'handleProfile',
    show_back: 'onShowBack',
    hide_back: 'onHideBack',
    login_as_other_user: 'loginAsOtherUser'
  };

  getCurrency = () => {
    return this.state.currency || constants.general.defaultCurrency;
  };

  handleChangeCurrency = (val) => {
    this.setState({ currency: val });
    this.emit('change_currency', val);
  };

  handleProfile = (profile) => {
    this.setState({ profile, user: profile });
  };

  onSetContact = (contact) => {
    const state = {
      contactUser: contact?.users.find((item) => item.id !== this.getUser()?.id),
      contactId: contact.id
    };
    if (!state.contactUser?.isDoctor) {
      state.isOpenBookAppointment = false;
    }
    this.setState(state);
  };

  onShowBack = (cb) => {
    this.setState({
      showBack: true,
      funcBack: cb
    });
  };

  onHideBack = () => {
    this.setState({
      showBack: false,
      funcBack: null
    });
  };

  loginAsOtherUser = ({ id }) => {
    popupModel.setActivePopup('loading', {
      active: true
    });
    if (this.getApiState('login').loading) return this.log('logAsDoctor: processing');
    const url = getRouter()?.location.pathname;
    this.api('login', { id, url }, (err, res, success) => {
      if (success) {
        this.emit('auth', res.session);
        this.foxsocket().disconnect();
        this.foxsocket().ensureConnect(true);
        getRouter().navigate('/');
        this.emit('accountSwitched', res.session);
      }

      popupModel.setActivePopup('loading', { active: false });
    });
  };
}

const model = new MainModel();
export default model;
